import { render } from "./RoleForm.vue?vue&type=template&id=c835ed54&ts=true"
import script from "./RoleForm.vue?vue&type=script&lang=ts"
export * from "./RoleForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Roles/RoleForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c835ed54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c835ed54', __exports__)) {
    api.reload('c835ed54', __exports__)
  }
  
  module.hot.accept("./RoleForm.vue?vue&type=template&id=c835ed54&ts=true", () => {
    api.rerender('c835ed54', render)
  })

}


export default __exports__